export class ShapeColorOptions {
    public strokeColor: string;
    public strokeOpacity: number;
    public strokeWeight: number;
    public fillColor: string;
    public fillOpacity: number;
    constructor(obj?: ShapeColorOptions) {
      if (obj) {
        this.strokeColor = obj.strokeColor;
        this.strokeOpacity = obj.strokeOpacity;
        this.strokeWeight = obj.strokeWeight;
        this.fillColor = obj.fillColor;
        this.fillOpacity = obj.fillOpacity;
      }
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/shape-color-options.ts